module.exports = __webpack_public_path__ + "img/vedio.9f83525c.png";